import React, { useState, useEffect } from 'react';
import { TableGrid } from '@C/TableGrid';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authHeader } from '@H';
import { confirmAlert } from 'react-confirm-alert';
import services from '@C/Admin/SmsSetup/_utils/data';

const col = [
  {
    name: 'Date',
    key: 'created_on',
    type: 'date',
  },
  {
    name: 'Dealer',
    key: 'bunk',
    formatter(props) {
      return <>{props.name}</>;
    },
  },
  {
    name: 'mobile',
    key: 'bunk',
    formatter(props) {
      return <>{props.mobile_number}</>;
    },
  },
  {
    name: 'Package requested',
    key: 'package',
    formatter(props) {
      return <>{props.name}</>;
    },
  },
  {
    name: 'Package Price',
    key: 'paid_amount',
    type: 'currency',
  },
  {
    name: 'Request Status',
    key: 'recharge_status',
  },
  {
    name: 'SMS Status',
    key: 'all',
    formatter(props) {
      return (
        <>
          {props.remaining_sms_count} / {props.package.sms}
        </>
      );
    },
  },
];

const SMSList = (props) => {
  const [listPending, setListPending] = React.useState([]);
  const [listRejected, setListRejected] = React.useState([]);
  const [state, setState] = useState({
    offsetPending: 1,
    countPending: 0,
    limitPending: 5,
    offsetRejected: 1,
    countRejected: 0,
    limitRejected: 5,
    recharge_status: 'PENDING',
    recharge_status_rejected: 'DECLINE',
  });

  useEffect(() => {
    getSMSRequestListPending();
  }, [state.offsetPending]);

  useEffect(() => {
    getSMSRequestListRejected();
  }, [state.offsetRejected]);

  const getSMSRequestListPending = () => {
    services
      .getSMSrequestList({
        limit: state.limitPending,
        offset: state.offsetPending,
        recharge_status: state.recharge_status,
      })
      .then((response) => {
        setListPending(response.data.data.results);
        setState((prev) => ({
          ...prev,
          countPending: response.data.data.count,
        }));
      });
  };
  const getSMSRequestListRejected = () => {
    services
      .getSMSrequestListRejected({
        limit: state.limitRejected,
        offset: state.offsetRejected,
        recharge_status_rejected: state.recharge_status_rejected,
      })
      .then((response) => {
        setListRejected(response.data.data.results);
        setState((prev) => ({
          ...prev,
          countRejected: response.data.data.count,
        }));
      });
  };

  const handlePaginationPending = (e) => {
    setState((prev) => ({ ...prev, offsetPending: e }));
  };
  const handlePaginationRejected = (e) => {
    setState((prev) => ({ ...prev, offsetRejected: e }));
  };

  const refreshLists = () => {
    getSMSRequestListPending();
    getSMSRequestListRejected();
  };

  const activateSMS = (e, action) => {
    const formData = {
      bunk_id: e.bunk.account_id,
      uuid: e.uuid,
      recharge_status: action,
    };
    const headers = authHeader(1);

    axios
      .put(`${process.env.API_URL}/sms-recharge/`, formData, { headers })
      .then(() => {
        toast.success(
          `SMS request ${action == 'ACTIVE' ? 'activated' : 'rejected'} successfully`,
        );
        refreshLists();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const confirmSMSAction = (e, mode) => {
    confirmAlert({
      title: `${mode == 'ACTIVE' ? 'Activate SMS Request' : 'Reject SMS Request'}`,
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => activateSMS(e, mode),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  const enabledActions = [
    {
      action: 'Approve',
      roles: ['Site Admin'],
      icon: 'approve',
      callback: (e) => {
        confirmSMSAction(e, 'ACTIVE');
      },
    },
    {
      action: 'Reject',
      roles: ['Site Admin'],
      icon: 'reject',
      callback: (e) => {
        confirmSMSAction(e, 'DECLINE');
      },
    },
  ];

  return (
    <>
      <section className="widget full-width">
        <header className="title-wrapper">
          <h3> Pending Requests </h3>
        </header>
        <main className="content-wrapper">
          <TableGrid
            col={col.filter((e) => e.name !== 'SMS Status')}
            row={listPending}
            offset={state.offsetPending}
            count={state.countPending}
            limit={state.limitPending}
            handlePagination={handlePaginationPending}
            enabledActions={enabledActions}
          />
        </main>
      </section>

      <section className="widget full-width">
        <header className="title-wrapper">
          <h3> Rejected Requests </h3>
        </header>
        <main className="content-wrapper">
          <TableGrid
            col={col.filter((e) => e.name !== 'SMS Status')}
            row={listRejected}
            offset={state.offsetRejected}
            count={state.countRejected}
            limit={state.limitRejected}
            handlePagination={handlePaginationRejected}
            enabledActions={enabledActions.filter(
              (e) => e.action === 'Approve',
            )}
          />
        </main>
      </section>
    </>
  );
};

export default SMSList;
